export const address = "0x80b43f81d2AB12584d131818570817452B96849F";
export const NFTaddress = "0xCf3A01F472d5ab1Aa14c7a90537B34725cE0AD5d";
